import { useState, useEffect } from 'react';

// ----------------------------------------------------------------------

export function useOffSetTop(top = 100) {
  const [offsetTop, setOffSetTop] = useState(false);

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset > top) {
        setOffSetTop(true);
      } else {
        setOffSetTop(false);
      }
    };
    return () => {
      window.onscroll = null;
    };
  }, [top]);

  return offsetTop;
}

// Usage
// const offset = useOffSetTop(100);
